<template>
  <duration-input
    :value="value"
    label="Arbeitszeit"
    :hide-details="hideDetails"
    :disabled="disabled"
    :loading="loading"
    @input="onInput"
  />
</template>

<script>
import DurationInput from '../selects/Duration'

export default {
  components: {
    'duration-input': DurationInput
  },
  props: {
    value: {
      type: [String, Number],
      default: "",
    },
    hideDetails: {
      type: Boolean
    },
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onInput (value) {
      this.$emit('input', value)
    }
  }
}
</script>
